import PersonIcon from "@mui/icons-material/Person";
const SidebarMenu = [{ icons: <PersonIcon />, label: "Rider", path: "" }];

export default SidebarMenu;
